import { useContext, useCallback, useMemo } from 'react'
import { ModalHistoryContext } from '@/v2/contexts/RoutesContext'

const useModals = () => {
  const history = useContext(ModalHistoryContext)

  const goTo = useCallback(
    (pathname, state) => {
      if (history?.push) {
        history.push(pathname, state)
      }
    },
    [history]
  )

  const goBack = useCallback(() => {
    if (history?.goBack) {
      history.goBack()
    }
  }, [history])

  const close = useCallback(() => {
    // Always close all modals by navigating to the background location
    if (history?.location?.state?.backgroundLocation) {
      const bg = history.location.state.backgroundLocation
      history.replace(bg.pathname + (bg.search || '') + (bg.hash || ''))
    } else if (history?.goBack) {
      // If no background location, just go back
      history.goBack()
    }
  }, [history])

  const closeAll = useCallback(() => {
    // Alias for close - they both do the same thing now
    close()
  }, [close])

  return useMemo(
    () => ({
      goTo,
      goBack,
      close,
      closeAll,
    }),
    [goTo, goBack, close, closeAll]
  )
}

export default useModals
